export default {
  idTitleLabel: 'Request ', 
  buttons: {
    back: 'Back'
  },
  updatedDateLabel: 'Last update {0} hs',
  message: 'Here you will find the files attached to this application pending review.\nWhen it is ruled, its status will change to Dictated and you will find here the detail',
  tabs: {
    information: 'Information',
    observations: 'Observations'
  },
  information: {
    invoice: {
      label: 'Invoice',
      authorizedAmount: 'Authorized Amount',
      productsTitle: 'Products',
      productStatus: {
        rejected: 'Rejected',
        approved: 'Approved'
      }
    }, 
    prescription: {
      label: 'Prescription',
      diagnosesTitle: 'Diagnoses',
      diagnosisStatus: {
        rejected: 'Rejected',
        approved: 'Approved'
      }
    },
    otherFiles: {
      addFilesButton: 'Add',
      title: 'Additional files (optional)',
      label: 'Necessary and relevant documents for authorization.'
    },
    settlementFiles: {
      title: 'Settlement',
      addButtonLabel: 'Attach settlement',
      message: 'It is necessary to attach a settlement file to terminate this request'
    },
    resultFiles: {
      label: 'Results'
    },
    payment: {
      label: 'Payment information',
      documentLabel: 'Document no.',
      accountLabel: 'Account:',
      bankLabel: 'Bank:',
      paymentDate: 'Payment date: '       
    },
    preview: {
      title: 'Preview',
      label: 'This file has no preview',
      actions: {
        cancel: 'Cancel',
        download: 'Download',
        delete: 'Delete'
      }
    },
    beneficiary: {
      name: 'Complete name',
      identification: 'Identification',
      percentage: 'Percentage'
    }
  },
  observations: {
    addOtherFileComment: 'A file was attached {name} to the request.',
    addOtherFiles: {
      title: 'Additional files',
      addFilesTitle: 'Attach additional files',
      uploadButton: 'Confirm',
      cancelButton: 'Cancel'
    },
    comments:{
      headerDatePrefix: 'Today {date}',
      noComments: 'No observations',
      inputLabel: 'Write your comment'
    } 
  }
}